import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const DataIdCalculatorGuidePage = () => <DataDrivenGuidePage slug="guide-data-id-calculator" />;

export default DataIdCalculatorGuidePage;
